import React from 'react';
import LaaniSymbol from '../Assets/LaaniLogo.png';
import check from '../Assets/check.svg';
import { collabApps, collabContent, collabText } from "../constants";
import Button from "./Button";
import Section from "./Section";
import { LeftCurve, RightCurve } from './Design/Institutions';
import { Link } from 'react-router-dom';


const Institutions = () => {
  return (
    <Section crosses>
      <div className="container lg:flex">
        <div className="max-w-[25rem] mx-auto lg:mx-0">
        <h2 className="text-4xl font-semibold mb-6 text-white lg:text-left text-center">
  Institutional-Grade Crypto Infrastructure
</h2>

<p className="text-gray-400 mb-8 lg:text-left text-center max-w-md">
  Laani empowers hedge funds, family offices, fintechs, and enterprises with battle-tested digital asset solutions. Unlock secure custody, instant settlement, and full-stack trading infrastructure—built for institutions.
</p>

<ul className="space-y-5 mb-10">
  {collabContent.map(item => (
    <li key={item.id} className="flex items-start gap-4">
      <img src={check} alt="check" className="w-6 h-6 mt-1" />
      <div>
        <h6 className="text-white font-medium">{item.title}</h6>
        {item.text && <p className="text-sm text-gray-400 mt-1">{item.text}</p>}
      </div>
    </li>
  ))}
</ul>

<div className="flex flex-col md:flex-row gap-4">
  <Link to="/institutional">
    <Button text="Get Started" className="w-full md:w-auto" />
  </Link>
  <Link to="https://calendly.com/lwazi-m">
    <Button text="Book a Demo" subduedButton className="w-full md:w-auto" />
  </Link>
</div>

        </div>

        <div className="lg:ml-auto xl:w-[38rem] mt-4">
          <p className="body-2 mb-6 text-n-4 md:mb-16 lg:mb-32 lg:w-[22rem] lg:mx-auto text-center lg:text-left">
            {collabText}
          </p>

          <div className="relative left-1/2 flex w-full md:w-[22rem] aspect-square border border-n-6 rounded-full -translate-x-1/2 scale-75 md:scale-100 mx-auto lg:mx-0">
            <div className="flex w-60 aspect-square m-auto border border-n-6 rounded-full">
              <div className="w-[6rem] aspect-square m-auto p-[0.2rem] bg-conic-gradient rounded-full">
                <div className="flex items-center justify-center w-full h-full bg-n-8 rounded-full">
                  <img
                    src={LaaniSymbol}
                    width={48}
                    height={48}
                    alt="Laani Logo"
                  />
                </div>
              </div>
            </div>

            <ul>
              {collabApps.map((app, index) => (
                <li
                  key={app.id}
                  className={`absolute top-0 left-1/2 h-1/2 -ml-[1.6rem] origin-bottom rotate-${
                    index * 45
                  }`}
                >
                  <div
                    className={`relative -top-[1.6rem] flex w-[3.2rem] h-[3.2rem] bg-n-7 border border-n-1/15 rounded-xl -rotate-${
                      index * 45
                    }`}
                  >
                    <img
                      className="m-auto"
                      width={app.width}
                      height={app.height}
                      alt={app.title}
                      src={app.icon}
                    />
                  </div>
                </li>
              ))}
            </ul>

            <LeftCurve />
            <RightCurve />
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Institutions;


